export default __webpack_public_path__ + "static/media/logo_black.bd75b480.svg";